import React from "react";
const STATIC_OVERRIDES_COOKIE = "wixStaticsVersions";
const ARTIFACT_ID = "wix-ricos";
const QUERY_PARAM_KEY = `${ARTIFACT_ID}-override`;
const getQueryParam = (key) => {
  if (typeof window === "undefined") {
    return "";
  }
  const urlParams = new URLSearchParams(window.location.search);
  return decodeURIComponent(urlParams.get(key) || "");
};
const getCookie = (name) => {
  if (typeof document === "undefined") {
    return null;
  }
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(";").shift();
  }
  return null;
};
const getOverrideValue = () => {
  const overridesCookieValue = getCookie(STATIC_OVERRIDES_COOKIE);
  const cookiesValueMap = overridesCookieValue?.split("|").reduce(
    (acc, cookie) => {
      const [key, value2] = cookie.split("#");
      return { ...acc, [key]: value2 };
    },
    {}
  );
  const value = getQueryParam(QUERY_PARAM_KEY) || cookiesValueMap?.[ARTIFACT_ID];
  if (!value) {
    return null;
  }
  return value;
};
const isValidHash = (hash) => {
  return /^[a-f0-9]+$/.test(hash);
};
const isValidVersion = (version) => {
  return /^\d+\.\d+\.\d+$/.test(version);
};
const getOverrideUrl = () => {
  const value = getOverrideValue();
  if (!value) {
    return null;
  }
  if (value.startsWith("http://localhost") || value.startsWith("https://localhost")) {
    const url = new URL(value);
    return `${url.href}${url.href.endsWith("/") ? "" : "/"}full-ricos-editor.js`;
  }
  if (isValidVersion(value) || isValidHash(value)) {
    return `https://static.parastorage.com/services/${ARTIFACT_ID}/${value}/full-ricos-editor.js`;
  }
  return null;
};
const wixInsiderOverrideUrl = getOverrideUrl();
const hasWixInsiderOverride = !!wixInsiderOverrideUrl;
let overrideBundlePromise = null;
const loadOverrideBundle = () => {
  if (!overrideBundlePromise) {
    overrideBundlePromise = (0, eval)(`import('${wixInsiderOverrideUrl}')`).then(
      (bundled) => {
        bundled.loadCSS();
        return bundled;
      }
    );
  }
  return overrideBundlePromise;
};
const OverrideFullRicosEditorLazy = React.lazy(async () => {
  const bundled = await loadOverrideBundle();
  return { default: bundled.FullRicosEditor };
});
const useOverridePluginsMap = () => {
  const [pluginsMap, setPluginsMap] = React.useState(null);
  React.useEffect(() => {
    if (hasWixInsiderOverride) {
      loadOverrideBundle().then((bundled) => setPluginsMap(bundled.pluginsMap));
    }
  }, []);
  return pluginsMap;
};
export {
  OverrideFullRicosEditorLazy,
  getOverrideValue,
  hasWixInsiderOverride,
  useOverridePluginsMap
};
//# sourceMappingURL=overrides.js.map
